/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import React from 'react';
import { JoinSelfHelpBoxes } from '../HelpBoxes/JoinSelfHelpBoxes/JoinSelfHelpBoxes';

interface Props {
  id: string;
  heading: string;
  options: number;
  isInstantJoinOffered?: boolean;
}

export const JoinOptionsSection: React.FC<Props> = (props) => {
  const { heading, id, options, isInstantJoinOffered, children } = props;

  return (
    <Flex
      id={id}
      direction='column'
      alignContent='center'
      justifyContent='space-between'
      width='100%'
    >
      <Flex
        direction='column'
        alignItems='center'
        justifyContent='center'
        pt='16vh'
      >
        <Text as='h1' mb={6}>
          {heading}
        </Text>
        {options === 2 ? (
          <Flex
            alignItems='center'
            justifyContent='center'
            bgColor='white'
            borderRadius='0.25rem'
          >
            {children}
          </Flex>
        ) : (
          <Flex
            direction='column'
            alignItems='center'
            justifyContent='center'
            bgColor='white'
            borderRadius='0.25rem'
          >
            {children}
          </Flex>
        )}
      </Flex>
      {options === 2 ? (
        <JoinSelfHelpBoxes />
      ) : (
        <JoinSelfHelpBoxes
          meetingLinkWeb={
            isInstantJoinOffered ? window.location.href : undefined
          }
        />
      )}
    </Flex>
  );
};
